import { ParsedUrlQuery } from 'querystring';

/**
 * parseQueryParam
 * Intended for use with NextJS routing, where the query params may be of type string | string[]
 * Returns the first match for paramKey in params list
 *
 * Usage:
 *
 * const eventId = parseQueryParams(context.req.query, 'eventId');
 */
export function parseQueryParam(params: ParsedUrlQuery, paramKey: string, useLower = true): string | null {
  if (params && params[paramKey]) {
    const paramValue = params[paramKey];
    const firstParamValue = Array.isArray(paramValue) ? paramValue[0] : paramValue;
    if (useLower) {
      return firstParamValue.toLowerCase();
    }
    return firstParamValue;
  }
  return null;
}
